<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" 
  [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  
  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Manufacturer" class="w-1/2">
      <input pInputText [ngModel]="productType.manufacturer.name" disabled="true" />
    </uni-field>

    <uni-field label="Style" class="w-1/2">
      <input pInputText [ngModel]="productType.style" disabled="true" />
    </uni-field>
    
  </div>
  <div class="flex flex-row gap-3 mt-3">
    <uni-field label="Status" class="w-1/2">
      <p-dropdown [options]="activeStatuses" [(ngModel)]="product.activeStatusId" (ngModelChange)="onStatusChange($event)"
        optionValue="id" optionLabel="name" />
    </uni-field>

  </div>

  <ng-container *ngFor="let pfc of this.product.productFeatureChoices; let i = index;">
    <div class="flex flex-row gap-3">
      <uni-field label="Feature" clas="w-1/2">
        <input pInputText [ngModel]="pfc.featureChoice.feature.name" disabled="true" />
      </uni-field>
      
      <uni-field label="Feature Choice" class="w-1/2">
        <p-dropdown [options]="pfc.featureChoice.feature.featureChoices" [(ngModel)]="pfc.featureChoiceId"
          optionValue="id" optionLabel="choiceValue" [disabled]="!isAdding" />
      </uni-field>
    </div>
  </ng-container>

</ng-template>

<ng-template #footerTemplate>
  <div class="flex flex-row gap-2">
    <button [disabled]="!this.uow.hasChanges()" (click)="ok()" 
      pButton type="button" class="p-button-raised">
      Ok
    </button>
    <button (click)="cancel()"
      pButton type="button" class="p-button-raised">
      Cancel
    </button>
  </div>
</ng-template>